export default __webpack_public_path__ + "static/media/373.b22d37ee.gif";